import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { Store } from '@ngrx/store';
import { CoreActions } from '../stores/actions/core.actions';
import { MessageService } from 'primeng/api';

@Injectable()
export class OrganiserGuard implements CanActivate {
  private readonly _authService = inject(AuthService);
  private readonly _router = inject(Router);
  private readonly _store = inject(Store);
  private readonly _messageService = inject(MessageService);
  private readonly guardPermissions: string[] = [
    'Admin',
    'Super Admin',
    'Organiser'
  ]

  canActivate(activatedRoute: ActivatedRouteSnapshot) {
    const validToken = this._authService.hasValidToken();
    if (validToken) {
        const authCheck = this._authService.currentToken?.Permissions.some(x => this.guardPermissions.includes(x))
        if (!authCheck){
            this._messageService.add({ severity: 'warn',summary: 'Unauthorized Access', detail: "You don't have access to that page"})
            return this._router.createUrlTree(['/']);
        }
        return authCheck
    }
    this._store.dispatch(CoreActions.setRedirectURL({ redirectUrl: activatedRoute.url.join('/') }))
    return this._router.createUrlTree(['/login']);
  }
}